import { useMutation, useQuery } from "@tanstack/react-query";

import useAxios from "../common/hooks/useAxios";
import { useAuth } from "../core/contexts/AuthContextProvider";
import {
  CUSTOMER_LOGIN,
  CUSTOMER_REGISTER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
  USER_LOGIN,
} from "../loginContainer/api/login-api";
import {
  GET_LOGGED_CUSTOMER,
  GET_LOGGED_USER,
} from "../userManagement/api/users-api";
import { KEY_USER_TYPE } from "../core/variables";

export const AUTH_QUERIES = {
  userLogin: "userLogin",
  customerLogin: "customerLogin",
  customerRegister: "customerRegister",
  getLoggedUser: "getLoggedUser",
};

const useAuthApi = (enabledApis = []) => {
  const axios = useAxios();

  const isCustomer = () => localStorage.getItem(KEY_USER_TYPE) === "customer";

  const {
    data: loggedUser,
    isFetching: isLoggedUserLoading,
    refetch: fetchLoggedUser,
  } = useQuery({
    queryKey: [AUTH_QUERIES.getLoggedUser],
    queryFn: () =>
      axios
        .get(isCustomer() ? GET_LOGGED_CUSTOMER : GET_LOGGED_USER)
        .then((res) => res.data),
    enabled: false,
  });

  const { mutateAsync: userLogin, isPending: isUserLoginLoading } = useMutation(
    {
      mutationFn: (data) =>
        axios.post(USER_LOGIN, data).then((res) => res.data),
    }
  );

  const { mutateAsync: customerLogin, isPending: isCustomerLoginLoading } =
    useMutation({
      mutationFn: (data) =>
        axios.post(CUSTOMER_LOGIN, data).then((res) => res.data),
    });

  const { mutateAsync: register, isPending: isRegisterLoading } = useMutation({
    mutationFn: (data) =>
      axios
        .post(CUSTOMER_REGISTER, data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => res.data),
  });

  const { mutateAsync: forgotPassword, isPending: isForgotPasswordLoading } =
    useMutation({
      mutationFn: (data) =>
        axios.post(FORGOT_PASSWORD(data)).then((res) => res.data),
    });

  const { mutateAsync: resetPassword, isPending: isResetPasswordLoading } =
    useMutation({
      mutationFn: (data) =>
        axios.post(RESET_PASSWORD, data).then((res) => res.data),
    });

  return {
    userLoginApi: {
      execute: userLogin,
      isLoading: isUserLoginLoading,
    },
    customerLoginApi: {
      execute: customerLogin,
      isLoading: isCustomerLoginLoading,
    },
    customerRegisterApi: {
      execute: register,
      isLoading: isRegisterLoading,
    },
    loggedUserApi: {
      execute: fetchLoggedUser,
      isLoading: isLoggedUserLoading,
      data: loggedUser,
    },
    forgotPasswordApi: {
      execute: forgotPassword,
      isLoading: isForgotPasswordLoading,
    },
    resetPasswordApi: {
      execute: resetPassword,
      isLoading: isResetPasswordLoading,
    },
  };
};

export default useAuthApi;
